<template>
  <div class="space-y-4">
    <div v-if="files.length > 0" class="grid grid-cols-4 gap-x-6">
      <FilePreviewBlock
        v-for="(file, index) in files"
        :file="file"
        @removed="() => handleRemoveClick(index)"
      />
    </div>

    <div
      @click="handleClick"
      class="cursor-pointer rounded-lg border-4 border-dashed bg-gray-50 p-4 hover:border-gray-300 dark:bg-gray-700 dark:hover:border-gray-600 dark:hover:bg-gray-900"
      :class="
        startedDrag
          ? 'border-gray-300 dark:border-gray-600'
          : 'border-gray-200 dark:border-gray-700'
      "
      @dragenter.prevent="handleOnDragEnter"
      @dragleave.prevent="handleOnDragLeave"
      @dragover.prevent
      @drop.prevent="handleOnDrop"
    >
      <div
        class="flex flex-col items-center gap-3 text-center md:flex-row md:items-center md:gap-4 md:text-start"
      >
        <p class="pointer-events-none w-full md:w-auto">
          <Button as="div" class="w-full justify-center md:w-auto">
            {{ __('Choose a file') }}
          </Button>
        </p>

        <p
          class="pointer-events-none text-sm font-semibold leading-snug text-gray-500 dark:text-gray-400"
        >
          {{
            multiple
              ? __('Drop files or click to choose')
              : __('Drop file or click to choose')
          }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useLocalization } from '@/composables/useLocalization'
import { useDragAndDrop } from '@/composables/useDragAndDrop'
import { Button } from 'laravel-nova-ui'

const { __ } = useLocalization()

const emit = defineEmits(['fileChanged', 'fileRemoved'])

const { startedDrag, handleOnDragEnter, handleOnDragLeave, handleOnDrop } =
  useDragAndDrop(emit)

defineProps({
  files: Array,
  handleClick: Function,
})

function handleRemoveClick(index) {
  emit('fileRemoved', index)
}
</script>
